import { render, staticRenderFns } from "./ProjetManager.vue?vue&type=template&id=2d3f3d1e&"
import script from "./ProjetManager.vue?vue&type=script&lang=js&"
export * from "./ProjetManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports